import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { Tools } from "@comunicare/comunicare-helper";
import { GroupResponse, IQuestionQuestionnaire } from "@comunicare/comunicare-interfaces";
import { QuestionnaireResponse } from "src/app/models/questionnaireResponse.model";

export class QRDetailsDataSource extends MatTableDataSourceExtended<IQuestionQuestionnaire> {
  public responses: QuestionnaireResponse;
  public groups: GroupResponse[];
  public page: number;
  sortingDataAccessor = (data: IQuestionQuestionnaire, sortHeaderId: string): string | number => {
    switch (sortHeaderId) {
      case "name":
        return Tools.suppressDiacritics(data.text).toLowerCase();

      case "answer": {
        const question = this.groups?.[this.page]?.question?.find((q) => q.linkId === data.linkId);
        if (!question) {
          return "";
        }
        const answer = question?.answer?.[0]?.valueCoding?.display;
        if (!answer || answer === undefined) {
          return "";
        } else if (this.isNumber(answer)) {
          return Number(answer);
        } else {
          return Tools.suppressDiacritics(answer).toLowerCase();
        }
      }
      default:
        return "";
    }
  };

  constructor(responses: QuestionnaireResponse, groups: GroupResponse[]) {
    super();
    this.responses = responses;
    this.groups = groups;
  }

  public loadData(QR: IQuestionQuestionnaire[], page: number): void {
    this.page = page;
    this.data = QR;
  }

  private isNumber(value: string | number): boolean {
    return value !== null && value !== "" && !isNaN(Number(value.toString()));
  }
}
